import React from 'react'
import '../css/AboutUs.css'
import Dc from '../image/Dc.svg'
import Location from '../image/location.svg'
import Money from '../image/money.svg'
import Doctorimage from '../image/DoctorImage.svg'

function AboutUs() {
  return (
    <div className='container-fluid'>

      <div className="row AlignCenter">
              <div className="col-3">
                <h1 className="TextName01">About Us !</h1>
              </div>
              <div className="col-4">
              <ul class="nav navAlign" role="tablist">
          <li class="nav-item Widthsize11">
            <a class="nav-link active demo" data-bs-toggle="pill" href="#home">Patient </a>
          </li>
          <li class="nav-item Widthsize12">
            <a class="nav-link demo" data-bs-toggle="pill" href="#menu1">Doctor</a>
          </li>
        </ul>
              </div>
              <div className="row Align0200">
                <div className="col-12 p-0">
              <div class="tab-content">
          <div id="home" class="container tab-pane active mmy1">
            <div className="container-fluid">
            <div className="row DeMo01">
              <div className="col-9 mt-4 ">
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora error ipsam ullam fugit, cum cupiditate illum eveniet porro blanditiis repellat sint vitae aut optio similique non ad necessitatibus incidunt iste!Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora error ipsam ullam fugit, cum cupiditate illum eveniet porro blanditiis repellat sint vitae aut optio similique non ad necessitatibus incidunt iste! </p>
                <img className='ImageAliGn' src={Doctorimage} alt="" />
              </div>
              <div className="col-8">
                <div className="row mt-3">
                  <div className="col-4">
<div className="Grid01">
  <img src={Dc} alt="" />
  <h2 className='Header01'>Responsive Doctors</h2>
</div>
                  </div>
                  <div className="col-4">
                  <div className="Grid01">
  <img src={Location} alt="" />
  <h2 className='Header01'>Responsive Doctors</h2>
</div>
                  </div>
                  <div className="col-4">
                  <div className="Grid01">
  <img src={Money} alt="" />
  <h2 className='Header01'>Responsive Doctors</h2>
</div>
                  </div>
                </div>
              </div>
              <div className="col-9">
                <h2 className='TextAliGn'>Who we are !</h2>
                <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dicta ipsam natus nisi ratione sunt consequatur quibusdam et quaerat similique, iure dolor explicabo fugit animi quisquam, sed debitis rem, nemo illo!Lorem Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dicta ipsam natus nisi ratione sunt consequatur quibusdam et quaerat</p>
              </div>
              <div className="col-11">
              <h2 className='TextAliGn01'>What we do !</h2>
              <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dicta ipsam natus nisi ratione sunt consequatur quibusdam et quaerat similique, iure dolor explicabo fugit animi quisquam, sed debitis rem, nemo illo!Lorem Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dicta ipsam natus nisi ratione sunt consequatur quibusdam et quaerat</p>
              </div>
            </div>
            </div>  
          </div>
          <div id="menu1" class="container tab-pane fade mmy1">
            <h3>Order...</h3>
            <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
          </div>
        </div>
        </div>
              </div>
              </div>
    </div>
  )
}

export default AboutUs